import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { ScrollArea } from "../components/ui/scroll-area";
import { MessageSquare, Mic } from "lucide-react";
import { format } from "date-fns";
import { getThoughts } from "../services/supabase/thoughts";
import React from "react";

export function ThoughtsList() {
  const navigate = useNavigate();
  
  const { data: thoughts, isLoading } = useQuery({
    queryKey: ["thoughts"],
    queryFn: getThoughts
  });

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-full">
        <p className="text-muted-foreground">Loading thoughts...</p>
      </div>
    );
  }

  return (
    <div className="container mx-auto space-y-6 p-4">
      <h1 className="text-3xl font-bold">Your Thoughts</h1>
      <ScrollArea className="h-[calc(100vh-200px)]">
        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          {thoughts?.map((thought) => (
            <Card 
              key={thought.id} 
              className="hover:bg-accent cursor-pointer border border-gray-300 transition-colors"
              onClick={() => navigate(`/app/thoughts/${thought.id}`)}
            >
              <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
                <CardTitle className="text-sm font-medium">
                  {format(new Date(thought.created_at || ''), "PPP")}
                </CardTitle>
                {thought.audio_url ? (
                  <Mic className="h-4 w-4 text-muted-foreground" />
                ) : (
                  <MessageSquare className="h-4 w-4 text-muted-foreground" />
                )}
              </CardHeader>
              <CardContent>
                <p className="text-sm text-muted-foreground line-clamp-3">{thought.content}</p>
                {Array.isArray(thought.tags) && thought.tags.length > 0 && (
                  <div className="flex gap-2 mt-4 flex-wrap">
                    {thought.tags.map((tag) => (
                      <span
                        key={tag.id}
                        className="inline-flex items-center rounded-full bg-primary/10 px-2.5 py-0.5 text-xs font-medium text-primary"
                      >
                        {tag.name}
                      </span>
                    ))}
                  </div>
                )}
              </CardContent>
            </Card>
          ))}
        </div>
      </ScrollArea>
    </div>
  );
}